"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Paper = void 0;
var Paper_1 = require("./Paper");
Object.defineProperty(exports, "Paper", { enumerable: true, get: function () { return __importDefault(Paper_1).default; } });
//# sourceMappingURL=index.js.map